<template>
  <survey-management />
</template>

<script>
import SurveyManagement from "@/components/surveyManagement/SurveyManagement.vue";
export default {
  name: "CorpSurveyResultManagement",
  components: {
    "survey-management": SurveyManagement,
  },
  data() {
    return {};
  },
};
</script>
